import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";
import MeiliSearch from "meilisearch";

const meilisearchUrl: string = process.env.NEXT_PUBLIC_MEILISEARCH_HOST as string;
const meilisearchClientSearchApiKey: string = process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY as string;
const meiliseachAdminKey = process.env.MEILISEARCH_ADM_API_KEY as string;

export const instantSearchClient = instantMeiliSearch(
  `${meilisearchUrl}`,
  meilisearchClientSearchApiKey,
  {
    placeholderSearch: true,
  }
);
 
export const meiliseachLeads = new MeiliSearch({
  host: meilisearchUrl,
  apiKey: meiliseachAdminKey,
});

export const meiliSearchClient = new MeiliSearch({
  host: meilisearchUrl,
  apiKey: meilisearchClientSearchApiKey,
});
